module.exports = __webpack_public_path__ + "static/media/instagram.c37ff4d0.svg";